import React from 'react';
import styled from 'styled-components';
import hero from '../images/404-hero.png';
import Button from './Button';
import WidthWrapper from './WidthWrapper';

const StyledNoPageHero = styled.section`
  display: flex;
  width: 100vw;
  justify-content: center;
  flex-grow: 1;

  .left {
    background-color: var(--neutral100);
    width: 100%;
  }

  .width-wrapper {
    max-width: 39.5rem;
    width: 100%;
    margin: 0 0 0 auto;
    padding: 5rem 2rem;
  }

  .content {
    max-width: 29.6875rem;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
  }

  .image {
    width: 100%;
    height: 33.5rem;
  }

  .image img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .heading-s-semibold {
    margin-bottom: 0.5rem;
  }

  .heading-2xl-ultralight {
    text-transform: uppercase;
  }

  @media only screen and (max-width: 750px) {
    flex-direction: column;

    .width-wrapper {
      margin: 0 auto;
      max-width: 100%;
      padding: 3.5rem 2rem;
    }

    .image {
      height: 30rem;
    }
  }
`;

const NoPageHero = () => {
  return (
    <StyledNoPageHero>
      <div className="left">
        <WidthWrapper>
          <div className="content">
            <h2 className="heading-s-semibold">404</h2>
            <h3 className="heading-2xl-ultralight">Looks like this page went on vacation</h3>
            <div className="description">
              Let’s get you back on track. Visit our homepage or check out our client success
              stories.
            </div>
            <Button text="Take me Home" link="/" />
          </div>
        </WidthWrapper>
      </div>
      <div className="image">
        <img src={hero} alt="Palm trees" />
      </div>
    </StyledNoPageHero>
  );
};

export default NoPageHero;
